import { PropertyType } from '../../../common';

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	uid: data.userId,
	sid: data.token,
	profile_image: data.image,
});
